import type { SlideData, SlideTemplate } from "@ai-teach/types";

const nullMedia = { src: null, id: null, filename: null };

/** The empty slideData a newly authored slide starts from, keyed by the template it renders as. */
export function getDefaultSlideData(template: SlideTemplate): SlideData {
  switch (template) {
    case "vocabulary":
    case "wordCanvas":
      return {
        word: null,
        wordAudio: nullMedia,
        syllable: null,
        syllableAudios: [],
        image: nullMedia,
        isVideoWithImage: false,
      };

    case "listenRepeat":
      return {
        image: nullMedia,
        video: nullMedia,
        audio: nullMedia,
        correctAnswer: "Your Answer",
        instructionText: "",
        mediaType: "image",
        gradingMode: "strictMode",
      };

    case "conversation":
    case "audioRevealPrompt":
      return {
        text: null,
        image: null,
        audio: null,
        correctAnswer: null,
      };

    case "videoQuestion":
      return {
        mediaType: "video",
        video: nullMedia,
        audio: nullMedia,
        checkpoints: [],
        subtitles: [],
        firstQuestionTime: 0,
      };

    case "passageReading":
      return {
        passages: [],
        isTextOnly: false,
        subQuizzes: [],
      };

    case "soundToSpelling":
      return {
        audio: nullMedia,
        phoneme: null,
        questionMode: "multiple_choice",
        correctAnswer: null,
        options: [],
      };

    case "spellingToSound":
      return {
        audio: nullMedia,
        phoneme: null,
        phonemeId: null,
      };

    case "freeformCanvas":
      return {
        text: null,
        subQuizzes: [],
      };

    case "handWriting":
      return {
        image: nullMedia,
        text: ["A"],
        textAudios: [],
      };

    // A new template MUST get a case, or an authored slide starts with the wrong shape.
    default: {
      const unhandled: never = template;
      throw new Error(`getDefaultSlideData: unhandled slide template "${unhandled}"`);
    }
  }
}
